import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { AccessLayout, PersonalPath } from 'entities/ExportRouters'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'

export const AccountAccessLayout = observer(() => {
  return (
    <AccessLayout
      name={EnumAccessPageKeys.settings_profile}
      onAccessDenied={() => {
        uiStore.changeRouteViaVue({
          method: 'replace',
          path: `/${PersonalPath.profile}`,
        })
      }}
    />
  )
})
